import "./Banner.css";

export const Banner: React.FC<{}> = () => {
  return (
    <div className="banner">
      <img src="/img/shapka_2.svg" />
    </div>
  );
};
